import mintalMesPrd from "@/store/mintalMes/prd/moduleIndex-store-mintalMes-prd";
import mintalMesMst from "@/store/mintalMes/mst/moduleIndex-store-mintalMes-mst"
import mintalMesQuality from "@/store/mintalMes/quality/moduleIndex-store-mintalMes-quality"
import mintalMesInventory from "@/store/mintalMes/inventory/moduleIndex-store-mintalMes-inventory"

const entities = {
    ...mintalMesPrd,
    ...mintalMesMst,
    ...mintalMesQuality,
    ...mintalMesInventory
}

export default entities